// @flow strict

import * as React from 'react';

type KeyboardEventType = 'keydown' | 'keyup';

type Props = {|
  /** Keyboard event types we support. Could add more if necessary (e.g., keypress) */
  eventType: KeyboardEventType,

  /**
   * The key or keys to listen for.
   * See this site for getting key codes: https://javascript.info/keyboard-events
   */
  keyName: string | Array<string>,

  /**
   * The callback function to execute when a key code matches. Note that the event type is 'KeyboardEvent' and not
   * 'SyntheticKeyBoardEvent' because this is a DOM event fired from window.addEventListener() as opposed to coming from
   * react.
   */
  callback: (e: KeyboardEvent) => mixed,
|};

/**
 * An event handle for keyboard events. A callback is executed when the provided key code is fired.
 */
export default class KeyboardEventListener extends React.Component<Props> {
  static defaultProps = {
    eventType: 'keydown',
  };

  constructor(props: Props) {
    super(props);
    this.keyNames = Array.isArray(props.keyName) ? props.keyName : [props.keyName];
  }

  componentDidMount() {
    // eslint-disable-next-line no-restricted-globals
    window.addEventListener(this.props.eventType, this.handleEvent);
  }

  componentWillUnmount() {
    // eslint-disable-next-line no-restricted-globals
    window.removeEventListener(this.props.eventType, this.handleEvent);
  }

  keyNames: Array<string>;

  handleEvent = (e: KeyboardEvent) => {
    const { key } = e;
    if (!key) {
      return;
    }
    if (this.keyNames.indexOf(key) !== -1) {
      this.props.callback(e);
    }
  };

  render() {
    return null;
  }
}
